
class ShapeRadialGroupArgs {
    // Radials from center point to edges
    // The idea here is to expand a circle, but do so with shrinking 
    // outer layers. 
    //
    //// General config
    // centerPt     - Object (with x, y members).
    //              allows picking a custom center point  
    // isCentered   - Will center the radial at the current param location,
    //                insteading of having its starting edge there.
    // connectPoints - Draw straight lines between points instead of 
    //                 using the relative arcs.
    //
    //// Patterns to repeat within a group
    // arcAttenRepeat - Matrix, numbers to do a repetetive shrink/grow 
    //                   width of the radials to build patterns with
    //                   for each group.
    // attenuateRadius - Matrix (number) - array that will be repeated 
    //                   to grow/shrink the radius of radials for 
    //                   each group.
	//
    //// Grouping arguments. create shapes in groups with 
    //   changes between groups.
    // groups  - array of number. Overrides most of the above arguments and 
    //           applies only select change args after each group is complete.
    // groupArcs   - Array of number. Resets the arc size (arc sweep)
    //                of radials to the given value
    //                for groups after the initial one.  
    // groupRadii   - Array of number. Changes the radius of arcs for subsequent groups
    // groupSteps   - Array of number. Changes the step size for subsequent groups.  

    constructor(
    ) {
        this.centerPts = []
        this.isCentered = false
        this.connectPoints = false

        this.arcChangeRepeat = [[1, 1]]
        this.radiusChangeRepeat = [[1, 1]]

        this.groups = []
        this.groupArcs = []
        this.groupRadii = []
        this.groupSteps = []
    }

    setCenterPts(centerPts) {
        this.centerPts = centerPts
        return this
    }

    setIsCentered(isCentered) {
        this.isCentered = isCentered
        return this
    }

    setConnectPoints(connect) {
        this.connectPoints = connect
        return this
    }

    // will add them into arc calculations in repeating fashion
    setSizeChangeRepeat(arcChangeRepeat) {
        this.arcChangeRepeat = arcChangeRepeat
        return this
    }

    // Take an array of two or more float, 
    // will add them into radius calculations in repeating fashion
    setRadiusChangeRepeat(radiusChangeRepeat) {
        this.radiusChangeRepeat = radiusChangeRepeat
        return this
    }

    setGroups(groups) {
        this.groups = groups
        return this
    }

    setGroupArcs(arcs) {
        this.groupArcs = arcs
        return this
    }

    setGroupRadii(radii) {
        this.groupRadii = radii
        return this
    }

    setGroupSteps(steps) {
        this.groupSteps = steps
        return this
    }

    getCenterPts() {
        return this.centerPts.slice(0)
    }

    getGroups() {
        return this.groups.slice(0)
    }

    getGroupArcs() {
        return this.groupArcs.slice(0)
    }

    getGroupRadii() {
        return this.groupRadii.slice(0)
    }

    getGroupSteps() {
        return this.groupSteps.slice(0)
    }

    getSweepChangeRepeat(n) {
        return this.arcChangeRepeat.length > n ? this.arcChangeRepeat[n] : this.arcChangeRepeat[0]
    }

    getRadiusChangeRepeat(n) {
        return this.radiusChangeRepeat.length > n ? this.radiusChangeRepeat[n] : this.radiusChangeRepeat[0]
    }

}

export { ShapeRadialGroupArgs }
